import React, { FC } from 'react';
import './BetaBadge.scss';

export const BetaBadge: FC = () => {
  return <div className="betaBadge">Beta</div>;
};
